import {
  Component,
  Input,
  ComponentFactoryResolver,
  ViewChild,
  OnInit,
  Type,
  ComponentRef,
  ViewContainerRef,
  EventEmitter,
  Output
} from "@angular/core";
import { Subscription } from "rxjs";
import { Tab } from "../../models/tab.model";
import { TabService } from "../../services/tab.service";
import { ContentContainerDirective } from "./content-container.directive";

export interface SkeletonComponent<T, U> {
  data: T;
  eventOutput : EventEmitter<U>;
}

@Component({
  selector: 'app-tab-content',
  template: '<ng-template content-container></ng-template>',
  styleUrls: ['./tab-content.component.scss']
})
export class TabContentComponent implements OnInit {

  public componentRef : Array<ComponentRef<any>> = [];
  @ViewChild(ContentContainerDirective, { static: true }) contentContainer: ContentContainerDirective | undefined;
  @Output() eventOutput: EventEmitter<any> = new EventEmitter<any>();

  private _subscriptions : Array<Subscription> = [];

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
    private tabService: TabService) {}

  ngOnInit() {
    this._subscriptions.push(
      this.tabService.tabSubscription<any>().subscribe((tabs : Array<Tab<any>>) => {
        this._removeAllComponents();
        const activeTab = tabs.find(x=>x.active);
        if(activeTab) {
          this._addDynamicComponent(activeTab.component, activeTab.tabData);
        }
      })
    );  
  }

  private _addDynamicComponent(component : Type<any>, tabData : any) : void {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
    if(this.contentContainer) {
      const viewContainerRef : ViewContainerRef = this.contentContainer.viewContainerRef;
      let componentRef : ComponentRef<any> = viewContainerRef.createComponent(componentFactory);
      (componentRef.instance as SkeletonComponent<any, any>).data = tabData;
      (componentRef.instance as SkeletonComponent<any, any>).eventOutput.subscribe((res) => {
        this.eventOutput.emit(res)
      })
      this.componentRef.push(componentRef);
    }
  }

  private _removeDynamicComponent(component : Type<any>) : void {
    if(this.contentContainer) {
      const viewContainerRef : ViewContainerRef = this.contentContainer.viewContainerRef;
      let componentRef = this.componentRef.filter(x => x.componentType.name == component.name)[0];
      let vcrIndex: number = viewContainerRef.indexOf(componentRef as any);
      if(vcrIndex > -1) {
        viewContainerRef.remove(vcrIndex);
        this.componentRef = this.componentRef.filter(x => x.componentType.name == component.name);
      }
    }
  }

  private _removeAllComponents() : void {
    if(this.contentContainer) {
      const viewContainerRef : ViewContainerRef = this.contentContainer.viewContainerRef;
      viewContainerRef.clear()
    }
  }

}
